import React from 'react';
import { useAboutHook } from './Hooks';
import AboutComponent from './Component';

const About = () => {
  return <AboutComponent {...useAboutHook()} />
}
export default About;
